import { Route, Routes, Link } from 'react-router-dom';
import { useState } from 'react';
import './App.css';
import { HomePage } from './components/HomePage';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Container, Modal, Box } from '@mui/material';
import TwitterLogo from "./images/twitterLogo.svg";
import LinkedinLogo from "./images/linkedinLogo.svg";
import AboutPage from "./components/ServicePage";
import { ServicePage } from "./components/ServicePage";
import { ContratacionPublicaPage } from "./components/ContratacionPublicaPage";
import { DespachosJuridicosPage } from "./components/DespachosJuridicosPage";
import LogoLega from "./images/LegaLogo.png"
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleModalOpen = (title) => {
    setModalTitle(title);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setModalTitle("");
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientY);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientY);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isUpSwipe = distance > 50;
    const isDownSwipe = distance < -50;
    if ((isUpSwipe || isDownSwipe) && menuOpen) {
      closeMenu();
    }
  };

  const renderModalContent = () => {
    switch (modalTitle) {
      case "Law Firms":
        return (
          <>
            <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
              Law Firms Asociadas
            </h2>
          </>
        );

      case "Privacy Policy":
        return (
          <PrivacyPolicy/>
        );

      default:
        return null;
    }
  };

  return (
    <div>
      {/* Header con menú */}
      <header className="header">
        <Grid container className="div-logo">
          <img src={LogoLega} />
        </Grid>

        <div className="burger-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <CloseIcon /> : <MenuIcon />}
        </div>

        <nav 
          className={`header-links ${menuOpen ? 'open' : ''}`}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <Link to="/" onClick={closeMenu}>INICIO</Link>
          <Link to="/services" onClick={closeMenu}>SERVICIO</Link>
          <Link to="/contratacion" onClick={closeMenu}>CONTRATACIÓN PÚBLICA</Link>
          <Link to="/despachos" onClick={closeMenu}>DESPACHOS JURÍDICOS</Link>
          <Link to="/" onClick={closeMenu}>LOG IN</Link>
        </nav>
      </header>

      {/* Contenido central */}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/contratacion" element={<ContratacionPublicaPage />} />
          <Route path="/despachos" element={<DespachosJuridicosPage />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer>
        <Grid container
          alignItems="center"
          style={{ textAlign: "center" }}>
          <Grid size={{ xs: 3, md: 3 }}>
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
              <p>Home</p>
            </Link>
          </Grid>
          <Grid size={{ xs: 3, md: 3 }}>
            <p>Public Contracting</p>
          </Grid>
          <Grid size={{ xs: 3, md: 3 }}>
            <p onClick={() => handleModalOpen('Law Firms')} style={{ cursor: 'pointer' }}>Law Firms</p>
          </Grid>
          <Grid size={{ xs: 3, md: 3 }}>
            <p onClick={() => handleModalOpen('Privacy Policy')} style={{ cursor: 'pointer' }}>Privacy Policy</p>
          </Grid>
        </Grid>

        <Grid container spacing={2} className="footer-info">
          <Grid size={{ xs: 6, md: 4 }}>
            <img
              src={TwitterLogo}
              alt="Gráfica vision"
            />
          </Grid>
          <Grid size={{ xs: 6, md: 4 }}>
            <img
              src={LinkedinLogo}
              alt="Gráfica vision"
            />
          </Grid>
          <Grid size={{ xs: 6, md: 4 }}>
            <p>contacto@legabot.com.mx</p>
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, md: 12 }}>
          <p>© 2024 LegalTech Solutions. All rights reserved.</p>
        </Grid>
      </footer>

      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "900px",
            maxHeight: "80vh",
            bgcolor: "background.paper",
            borderRadius: "12px",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
            fontFamily: "Arial, sans-serif",
            lineHeight: 1.6,
          }}
        >
          <button
            onClick={handleModalClose}
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              background: "none",
              border: "none",
              fontSize: "24px",
              cursor: "pointer",
            }}
          >
            ×
          </button>

          {renderModalContent()}
        </Box>
      </Modal>
    </div>
  );
}

export default App;
